export const TOKEN_ADMIN = "accessTokenAdmin";
export const USER_ADMIN = "UserAdmin";
